// extracted by mini-css-extract-plugin
module.exports = {"clips-container":"styles-module__clips-container___1kYXt","clips-container-open-form":"styles-module__clips-container-open-form___3wEaO"};